import { useState, useEffect } from "react";
import {
  getOrCreateCaisse,
  getCaisseFromStorage,
  saveCaisseToStorage,
} from "../Services/CaisseApi";

export const useCaisse = () => {
  const [caisse, setCaisse] = useState(null);
  const [loading, setLoading] = useState(false);

  const initCaisse = async (user, organisation_id, nom_caisse = "") => {
    setLoading(true);
    try {
      // First check localStorage
      let storedCaisse = getCaisseFromStorage();

      if (storedCaisse && storedCaisse.user_id === user.id) {
        setCaisse(storedCaisse);
        setLoading(false);
        return storedCaisse;
      }

      // If not in storage, get/create from API
      const response = await getOrCreateCaisse(
        user.id,
        organisation_id,
        nom_caisse || `Caisse_${user.prenom}_${user.nom}`,
      );

      if (response?.data?.code === 200) {
        const caisseData = response.data.data;
        setCaisse(caisseData);
        saveCaisseToStorage(caisseData);
        setLoading(false);
        return caisseData;
      }
    } catch (error) {
      console.error("Error initializing caisse:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearCaisse = () => {
    setCaisse(null);
    localStorage.removeItem("caisse_data");
  };

  return { caisse, loading, initCaisse, clearCaisse };
};
